import { CARD_TYPE_MAP, CardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const CUSTOMIZATION_TYPES_MAP = new Map<CardType, string>([
  ['DETAILS', 'Enclosure card'],
  ['ENCLOSURE', 'Enclosure card'],
  ['ENVELOPE', 'Envelope'],
  ['HOLIDAY', 'Holiday'],
  ['INVITATION', 'Invitation'],
  ['MENU', 'Menu'],
  ['PLACE', 'Place card'],
  ['PROGRAM', 'Program'],
  ['SAVE_THE_DATE', 'Save the date'],
  ['CHANGE_THE_DATE', 'Change the date'],
  ['THANK_YOU', 'Thank you'],
  ['RSVP', 'RSVP'],
  [CARD_TYPE_MAP.weddingShower, 'Wedding shower invitation'],
  [CARD_TYPE_MAP.tableNumber, 'Table numbers'],
  [CARD_TYPE_MAP.bellyBand, 'Belly band'],
  [CARD_TYPE_MAP.vellumJacket, 'Vellum jacket'],
  [CARD_TYPE_MAP.waxSeal, 'Wax seal'],
]);
